<template>
  <div v-if="busy===false">
      <div v-if="(users && users.length>0) || tab=='all'" style="display: flex; flex-wrap: wrap;">


    <b-col xl="2" lg="3" md="4" sm="6" v-for="user in users" @click="getPrivateRoom(user.user_id)" class="text-center p-3" style="cursor: pointer;">
      <b-img fluid  :src="user.avatar" rounded="circle" alt="Circle image" />
      <small class="text-muted"><h6>{{user.name}}</h6></small>
    </b-col>



            <infinite-loading @infinite="infiniteHandler" :identifier="infiniteId">
          <div slot="no-more"></div>
            <div slot="no-results"></div>
        </infinite-loading>

  </div>
    <div v-else-if="tab=='friends'">
        <b-jumbotron header="Список пуст" lead='Что бы найти и добавить друзей перейдите на вкладку "Все"'>
            <p>После того как вы подпишетесь к пользователю, он появтся во вкладке "Интересные страницы". Как только пользователь подтвердит вашу заявку он переместится во вкладку "Друзья". Список ваших подписчиков отображается в разделе "Подписчики"</p>
            <b-button variant="primary" @click="$emit('toAll')">Перейти к списку всех пользователей</b-button>
        </b-jumbotron>
    </div>
      <div v-else>
        <b-jumbotron header="Список пуст" lead='Что бы найти и добавить друзей перейдите на вкладку "Все"'>
            <b-button variant="primary" @click="$emit('toAll')">Перейти к списку всех пользователей</b-button>
        </b-jumbotron>
      </div>
      <b-modal id="send_message" centered  lazy ref="messageWindow" :title="$t('mes')">
        <img :src="new_message_user.avatar" alt="" class="" style="width:96px; height:96px; border-radius: 3px;margin-right: 10px;">
       
          <h6 style="display: inline">{{new_message_user.name}}</h6>
      <div class="message-box my-1"><message ref="newMessageArea"></message></div>
        <div slot="modal-footer" class="w-100">
         <b-btn size="sm" class="float-right"  variant="primary" @click="sendMessage(new_message_user.user_id)">
           {{ $t('send') }}
         </b-btn>
       </div>
       </b-modal>
</div>
    </div>
</template>




<i18n>
{
  "en": {
    "send": "Send",
    "friend": "In your friend list",
    "subscribed": "You are subscribed",    
    "add": "Add to friends",    
    "follow": "Subscribe",    
    "nothing": "Nothing found",    
    "mes": "Send message"       
  },
  
  "ru": {
    "send": "Отправить",
    "friend": "В друзьях",
    "subscribed": "Вы подписаны",    
    "add": "Добавить в друзья",    
    "follow": "Добавить в друзья",    
    "nothing": "Ничего не найдено",
    "mes": "Отправить сообщение" 
  }
}
</i18n>


<script>
//  Import axios
import InfiniteLoading from 'vue-infinite-loading'
import message from '../layout/message'
const debounce = function (f, ms) {
  let timer = null;
  return function (...args) {
      const onComplete = () => {
          f.apply(this, args);
          timer = null;
      }
      if (timer) {
          clearTimeout(timer);
      }
      timer = setTimeout(onComplete, ms);
  };
}
export default {
  name: 'Users-list',
  components: {
    InfiniteLoading,
    message
  },
  props: ['tab','searchString'],
  data () {
    return {
      users: [],
      errors: [],
      busy: true,
      new_message_user: {},
      infiniteId: +new Date(),
      page:1
    }
  },
  // Fetches posts when the component is created.
  created () {
    this.fetchData()
  },
  watch: {
    // при изменениях маршрута запрашиваем данные снова
    '$route': 'fetchData',
    '$props.tab' () {
      this.busy=true;
      this.page = 1;
      this.users = [];
      this.infiniteId += 1;
      this.fetchData()
    },
    searchString (after, before) {
      this.search()
    }
  },
  methods: {
      getPrivateRoom(user_id){
        this.$http.post('chat/get-room?user_id='+user_id).then(({ data }) => {
         this.$store.state.open_room_id=data
       })
      },
    search: debounce(function () {
      this.fetchData()
    }, 500),
    login (user_id) {
      this.$auth.login({
        url: 'auth/login?user_id=' + user_id,
        redirect: {name: 'Index'},
      })
      .then(response => {
        console.log('success ' + this.context)
      }).catch(e => {
        this.error = e.response.data
      })
    },
    sendMessage (user_id) {
      var text = this.$refs.newMessageArea.text
        if (text) {
            this.$http.post('chat/message?user_id=' + this.user_id, {
                'message': text // Axios
            })
                    .then(response => {
                        this.$refs.newMessageArea.text = ''
                        this.$parent.hide()
                    }).catch(e => {
                alert('Ошибка')
            })
        } else {
            alert('Напишите сообщение')
        }
    },
     fetchData () {
      this.$http.post('social/user-search?tab='+this.tab+'&page=1', {
        UserSearch: this.searchString
      })
      .then(response => {
        this.users = response.data
        this.busy=false
        this.page += 1;
      })
      .catch(e => {
        this.errors.push(e)
      })
    },
    
    infiniteHandler ($state) {
        this.$http.post('social/user-search?tab='+this.tab+'&page=' + this.page, {
          UserSearch: this.searchString
        }).then(({ data }) => {
          
        if (data.length) {
          this.page += 1;
          this.users.push(...data);
          $state.loaded();
        } else {
          $state.complete();
        }

        })
    }
  }
}
</script>
<style scoped>
  .widget-followers-controls {
    float: right;
    bottom: 20px;
    position: absolute;
    right: 11px;
    border-radius: 10px;
}
</style>